import '../../../ProductCard/ProductCard.scss';
import './Wrapper.scss';

import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';

import { listerClickThrough } from '../../../../actions/lister-actions';
import AddToBasketButton from '../../../ProductCard/AddToBasket/AddToBasketButton';
import BackInStockButton from '../../../ProductCard/BackInStockButton';
import EnergyInformation from '../../../ProductCard/EnergyInformation/EnergyInformation';
import FinancePropositionEnhanced from '../../../ProductCard/FinancePropositionEnhanced';
import MoreInfo from '../../../ProductCard/MoreInfo';
import ProductImage from '../../../ProductCard/ProductImage/ProductImage';
import PromoFlag from '../../../ProductCard/PromoFlag';
import ReviewRating from '../../../ProductCard/ReviewRating/ReviewRating';
import { Context } from '../../store/store';
import LargeListViewSkeleton from '../ListViewContent/Skeletons/LargeListViewSkeleton';
import PricePodV2 from '../../../ProductCard/PricePod/V2/PricePodV2';
import { getTrueColourHex, isWhite } from '../../../../utils/trueColourMap';

const CardContentEnhanced = ({ product }) => {
	const [contextState] = useContext(Context);
	const { loaded } = contextState;

	const dispatch = useDispatch();
	const trueColourNormalised = product.TrueColour.replace(/_/g, ' ');

	if (!product) {
		return null;
	}

	if (!loaded) {
		return <LargeListViewSkeleton />;
	}

	return (
		<>
			<div className="flex flex-wrap relative">
				<div className="flex flex-col p-4 w-1/3 xl:w-2/12 justify-center">
					{product.State === 'OutOfStock' && (
						<div className="flex justify-center items-center rounded leading-snug bg-bread p-2 mt-2 text-title-sm text-error text-center hidden xl:block mb-3">
							<span className="ico ico-clock text-title text-error"></span>

							<span className="text-xs text-error">Out of stock</span>
						</div>
					)}
					<ProductImage {...product} />
				</div>

				<div className="w-2/3 xl:w-1/2 md:p-2 flex flex-col">
					<a
						href={product.FullProductUrl}
						onClick={(event) => {
							event.preventDefault();
							window.location.assign(product.FullProductUrl);

							dispatch(listerClickThrough(product.Code));
						}}
						className="inline-block"
						data-testid="product-card-link">
						<h2 className="text-title-sm xl:text-title-lg text-water md:text-secondary">
							{product.FullTitle}
						</h2>
					</a>

					<ReviewRating {...product} />

					<div className="hidden xl:block">
						<PromoFlag {...product} />
					</div>

					<div
						className="hidden xl:flex flex-1 items-stretch"
						data-tag-section="enhanced card spec">
						<a
							href={product.FullProductUrl}
							onClick={(event) => {
								event.preventDefault();
								window.location.assign(product.FullProductUrl);

								dispatch(listerClickThrough(product.Code));
							}}
							className="flex-1 flex mt-4 mr-2">
							<div
								className="border border-gray-30 border-solid rounded flex flex-col items-center justify-center py-6 w-full"
								data-tag-name="colour">
								<div
									className={`rounded-full h-8 w-8 mx-auto${
										isWhite(product.TrueColour, product.Colour)
											? ' border border-gray-50 border-solid'
											: ''
									}`}
									style={{
										backgroundColor: getTrueColourHex(
											product.TrueColour,
											product.Colour
										),
									}}
									role="img"></div>
								<div className="text-title-sm font-regular">
									{trueColourNormalised}
								</div>
							</div>
						</a>
						<a
							href={product.FullProductUrl}
							onClick={(event) => {
								event.preventDefault();
								window.location.assign(product.FullProductUrl);

								dispatch(listerClickThrough(product.Code));
							}}
							className="flex-1 flex mt-4 mr-2">
							<div
								className="border border-gray-30 border-solid rounded flex flex-col items-center justify-center py-6 w-full"
								data-tag-name="storage">
								<div className="text-display-sm">{product.StorageCapacity}</div>
								<div className="text-title-sm font-regular">Storage</div>
							</div>
						</a>
						<a
							href={product.FullProductUrl}
							onClick={(event) => {
								event.preventDefault();
								window.location.assign(product.FullProductUrl);

								dispatch(listerClickThrough(product.Code));
							}}
							className="flex-1 flex mt-4">
							<div
								className="border border-gray-30 border-solid rounded flex flex-col items-center justify-center py-6 w-full"
								data-tag-name="screen size">
								<div className="text-display-sm">{product.ScreenSize}</div>
								<div className="text-title-sm font-regular">Screen size</div>
							</div>
						</a>
					</div>
					<div className="xl:hidden">
						<div className="rating-info"></div>
						<EnergyInformation
							classes="flex mt-4 items-center mb-1"
							energyRatingDetails={product.EnergyRatingDetails}
						/>

						<div className="w-3/4">
							<PromoFlag {...product} />
						</div>

						{product && product?.State !== 'OutOfStock' && (
							<FinancePropositionEnhanced {...product} />
						)}
						<PricePodV2
							product={product}
							viewModel={product.PricePodViewModel}
							inStock={product.State !== 'OutOfStock'}
							{...product}
							enhancedCardLayout
						/>

						{product.State !== 'OutOfStock' && (
							<div className="hidden lg:flex" style={{ gap: '4px' }}>
								<MoreInfo
									{...product}
									classes="mt-2 w-1/2"
									enhancedCardLayout
								/>
								<AddToBasketButton classes="mt-2 w-1/2" {...product} />
							</div>
						)}

						{product.State === 'OutOfStock' && (
							<div className="z-10">
								<div className="flex justify-center items-center rounded leading-snug bg-bread p-3 mt-2 text-title-sm text-error text-center">
									<span className="ico ico-clock text-title-lg text-error"></span>

									<span className="text-title-sm text-error">Out of stock</span>
								</div>
								<BackInStockButton {...product} classes="mt-2" />
							</div>
						)}
					</div>
				</div>

				<div className="hidden xl:flex flex-col justify-start p-2 w-1/3">
					<div className="rating-info"></div>
					<EnergyInformation
						classes="flex mt-4 items-center mb-1"
						energyRatingDetails={product.EnergyRatingDetails}
					/>
					{product && product?.State !== 'OutOfStock' && (
						<FinancePropositionEnhanced {...product} />
					)}
					<div>
						<PricePodV2
							product={product}
							viewModel={product.PricePodViewModel}
							inStock={product.State !== 'OutOfStock'}
							{...product}
							enhancedCardLayout
						/>
					</div>

					{product.State !== 'OutOfStock' ? (
						<div className="flex" style={{ gap: '4px' }}>
							<MoreInfo {...product} classes="mt-2 w-1/2" enhancedCardLayout />
							<AddToBasketButton classes="mt-2 w-1/2" {...product} />
						</div>
					) : (
						<div>
							<BackInStockButton {...product} classes="mt-2" />
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default CardContentEnhanced;
